import {once} from './core.js';

const MOBILE_MEDIA = '(max-width: 767px)';

function findToggle(root) {
	if (root.matches?.('[data-mobile-category-toggle]')) {
		return root;
	}
	return root.querySelector?.('[data-mobile-category-toggle]');
}

export function init(root = document) {
	const toggle = findToggle(root);
	if (!toggle || !once(toggle, 'mobile-categories')) {
		return;
	}

	const panel = document.getElementById(toggle.getAttribute('aria-controls'));
	if (!panel) {
		return;
	}

	const media = window.matchMedia(MOBILE_MEDIA);
	const setExpanded = (expanded) => {
		toggle.setAttribute('aria-expanded', String(expanded));
		panel.classList.toggle('is-mobile-categories-open', expanded);
	};

	toggle.addEventListener('click', () => {
		setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
	});
	toggle.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
			setExpanded(false);
		}
	});
	media.addEventListener('change', () => setExpanded(false));
	setExpanded(false);
}
